import { createRouter, createWebHistory } from 'vue-router'
import { routes } from 'vue-router/auto-routes'
import { redirectToMarketingSite, resolveHostGate } from '@/lib/appHost'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

router.beforeEach((to) => {
  // Storybook mounts guest pages under localhost — skip host worlds there.
  if (import.meta.env.STORYBOOK) {
    return true
  }

  const gate = resolveHostGate(to.path)
  if (gate.type === 'marketing') {
    redirectToMarketingSite()
    return false
  }
  if (gate.type === 'home') {
    if (to.path === '/') {
      return true
    }
    return { path: '/', replace: true }
  }
  return true
})

export default router
